import LayoutsPageView from "./LayoutsPageView";

function LayoutsPage() {
  return <LayoutsPageView />;
}

export default LayoutsPage;
